import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Contributor from "../../atoms/Contributor";
import ContributorImage from "../../atoms/ContributorImage";
import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";

import { getAuthorName, multiAuthorSeperator } from "../../utils/utils";

import "./opinionStoryCard.m.css";

const OpinionStoryCard = ({ story, lang }) => {
  const authors = story.authors || [];
  const authorObj = story.authors && story.authors[0];
  const authorName = getAuthorName(story);
  const authorDisplayName = get(story, ["metadata", "story-attributes", "author-display-name", "0"], null);
  const hideAuthorName = get(story, ["metadata", "story-attributes", "hideauthor", 0], "no");
  const authorLocation = get(story, ["metadata", "author-location"], "").trim();

  return (
    <div styleName="base" className="opinion-story-card">
      {hideAuthorName !== "no" ? (
        <CardImage
          story={story}
          aspectRatio={[3, 2]}
          imageType="image3x2"
          showStoryTypeIcon={false}
          widths={[100, 100, 150]}
        />
      ) : authorDisplayName ? (
        <ContributorImage
          role={authorObj["contributor-role"]?.name}
          authorObj={authorObj}
          authorDisplayName={authorDisplayName}
        />
      ) : (
        <ContributorImage
          role={authorObj["contributor-role"]?.name}
          authorObj={authorObj}
          authorDisplayName={authorDisplayName}
        />
      )}
      <div styleName="story-details" className="story-details">
        <NewsHeadline story={story} cssStyleName="mediumBigSize" />
        <div styleName="author-details">
          {hideAuthorName === "no" &&
            (authors.length > 1 ? (
              authors.map((item, index) => (
                <Contributor
                  key={index}
                  name={item?.name}
                  seperator={multiAuthorSeperator(authors, lang, index)}
                  authorObj={item}
                  authorLocationForStory={authorLocation}
                />
              ))
            ) : (
              <Contributor
                name={authorName}
                authorObj={authorObj}
                contributorType={2}
                authorDisplayName={authorDisplayName}
                showBio={true}
                authorLocation={authorLocation}
              />
            ))}
        </div>
        {!authorName.match("লেখা") && authors.length > 1 && authorLocation && (
          <span styleName="author-location">{authorLocation}</span>
        )}
      </div>
    </div>
  );
};

OpinionStoryCard.propTypes = {
  story: object.isRequired,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
});

export default connect(mapStateToProps)(OpinionStoryCard);
